"use strict";

exports.__esModule = true;
exports.default = void 0;
/**
 * Safari on iOs don't respect the `overflow: hidden` style
 * and hence we can scroll the background with backdrop or dropdown etc.
 * This class is an attempt to prevent that scrolling.
 * TODO: Keep validating this against the latest Safari on iOs,
 *   if the issue is fixed natively then get rid of this class
 *   and associated code in other files.
 */
var IOSBodyScroll = /*#__PURE__*/function () {
  function IOSBodyScroll() {
    var _this = this;
    this.preventBodyScroll = function (e) {
      if (!e.target.closest(_this.selector)) {
        e.preventDefault();
      }
    };
    this.html = document.querySelector('html');
    this.body = document.body;
    this.selector = '';
    this.isIOS = /(iPhone|iPad|iPod)/.test(navigator.platform);
  }
  var _proto = IOSBodyScroll.prototype;
  _proto.lock = function lock(boundarySelector) {
    this.selector = boundarySelector;
    // Setting the passive option on your touch and wheel event listeners
    // can improve scrolling performance. if passive option is set to `true` then
    // `e.preventDefault()` will have no effect. Hence setting it to false.
    // For more details go here https://medium.com/@devlucky/about-passive-event-listeners-224ff620e68c
    this.isIOS && document.addEventListener('touchmove', this.preventBodyScroll, {
      passive: false
    });
  };
  _proto.unlock = function unlock() {
    this.isIOS && document.removeEventListener('touchmove', this.preventBodyScroll, {
      passive: false
    });
  };
  return IOSBodyScroll;
}();
var _default = exports.default = new IOSBodyScroll();